import script from "./SkeletonText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkeletonText.vue?vue&type=script&setup=true&lang=ts"

import "./SkeletonText.vue?vue&type=style&index=0&id=726ba6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726ba6ba"]])

export default __exports__